import useAuthSuccessCallback from './useAuthSuccessCallback'
import { selectRestPopupBody } from 'rest/restSlice'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import useEnterClick from 'hooks/useEnterClick'
import Submit from 'components/inputs/Submit'
import Input from 'components/inputs/Input'
import { useReduxSelector } from 'store'
import React, { useState } from 'react'

const PasswordPopup: React.FC = () => {

  const popupBody = useReduxSelector(selectRestPopupBody)
  const [token, setToken] = useState('')

  const successCallback = useAuthSuccessCallback()
  const { t } = useTranslation('auth')
  const submit = () => {
    successCallback({ success: true, token })
  }

  useEnterClick(() => {
    if (token) {
      submit()
    }
  })

  return (
    <div className='popup__pin popup__verification'>
      <div className='popup__title'>
        <div>{'title' in popupBody ? popupBody.title : t('enterYourPassword')}</div>
      </div>

      {popupBody && 'verified' in popupBody && popupBody?.verified === false && <p className='verification__warning'>{t('incorrectPassword')}</p>}

      <Input
        value={token}
        name='password'
        type='password'
        changeHandler={e => {
          setToken(e.target.value)
        }}
      />

      <div className='popup__buttons'>
        <Submit
          block={!token}
          action={submit}
          text={t('authorize')}
        />

        <BackBtn text={t('cancel')} />
      </div>
    </div>
  )
}

export default PasswordPopup